/* eslint-env browser */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'redux-router';
import shallowEqual from 'react-pure-render/shallowEqual';
import { setHeader, removeErrorMessage, removeFlashMessage, navigationHide, populateAuthStatus } from 'actions';
import classnames from 'classnames';
import includes from 'lodash/includes';
import { StyleRoot } from 'radium';
import auth from 'lib/Auth';

import Header from 'components/common/Header';
import Nav from 'components/common/Nav';

const NO_AUTH_ROUTES = [
  '/',
  '/login',
  '/handleToken',
  '/activate',
  '/signup',
];

class App extends Component {
  constructor(props) {
    super(props);
    this.handleHideClick = this.handleHideClick.bind(this);
    this.handleFlashHideClick = this.handleFlashHideClick.bind(this);
  }

  componentWillMount() {
    if (this.props.routerHistory[0].pathname !== '/handleToken') {
      const { authToken, userId } = auth.getAuthData();
      if (authToken && userId) {
        this.props.populateAuthStatus();
      }
    }

    // iOS fix to make sure the entire view is visible and not hidden behind URL bar
    setTimeout(() => {
      window.scrollTo(0, 1);
    }, 0);
  }

  componentWillReceiveProps(nextProps) {
    // Scroll to top when the route changed
    if (!shallowEqual(this.props.routerHistory, nextProps.routerHistory)) {
      // Don't auto-scroll to top if it was a 'backwards' router movement
      if (nextProps.routerHistory.length > this.props.routerHistory.length) {
        setTimeout(() => {
          window.scrollTo(0, 1);
        }, 200);
      }
    }

    // Scroll to top so error message is visible if we're showing a new message
    if (nextProps.errorState.visible && !shallowEqual(nextProps.errorState !== this.props.errorState)) {
      setTimeout(() => {
        window.scrollTo(0, 1);
      }, 0);
    }

    const nextPath = nextProps.routerHistory[0].pathname;

    if (nextProps.errorState.status === 401 && (!includes(NO_AUTH_ROUTES, nextPath))) {
      nextProps.removeErrorMessage();
      nextProps.push('/logout');
    }
  }

  handleHideClick(e) {
    this.props.removeErrorMessage();
    e.preventDefault();
  }

  handleFlashHideClick(e) {
    this.props.removeFlashMessage();
    e.preventDefault();
  }

  renderErrorMessage() {
    const { errorState } = this.props;
    if (!errorState.visible) {
      return null;
    }

    return (
      <p id="errorBar">
        <span className="message">{errorState.message}</span>
        <span className="clickable hide" title="dismiss" onClick={this.handleHideClick}>X</span>
      </p>
    );
  }

  renderFlashMessage() {
    const { flashMessage } = this.props;
    if (!flashMessage.visible) {
      return null;
    }

    return (
      <p id="flashMessageBar" className={flashMessage.messageType}>
        <span className="message">{flashMessage.message}</span>
        <span className="clickable hide" title="dismiss" onClick={this.handleFlashHideClick}>X</span>
      </p>
    );
  }

  render() {
    const { children, navigationVisible, modalVisible } = this.props;
    return (
      <StyleRoot>
        <div
          className={classnames({
            'nav-hidden': !navigationVisible,
            'nav-visible': navigationVisible,
            'modal-hidden': !modalVisible,
            'modal-visible': modalVisible,
          })}
        >
          <Nav />
          <Header />
          <span className="appContent">
            <section
              onClick={() => this.props.navigationHide()}
              className="content-overlay clickable"
            />
            {this.renderErrorMessage()}
            {this.renderFlashMessage()}
            {children}
          </span>
        </div>
      </StyleRoot>
    );
  }
}

function mapStateToProps(state) {
  return {
    headerContent: state.header,
    errorState: state.errorState,
    routerHistory: state.routerHistory,
    navigationVisible: state.navigation.isVisible,
    modalVisible: state.modal.isVisible,
    flashMessage: state.flashMessage,
  };
}

export default connect(mapStateToProps, {
  setHeader,
  removeErrorMessage,
  removeFlashMessage,
  push,
  navigationHide,
  populateAuthStatus,
})(App);



// WEBPACK FOOTER //
// ./src/app/containers/App.js